import React from "react";

const SvgMonitoraViceznacny = props => (
    <svg viewBox="0 0 197.37 99.38" {...props}>
        <defs>
            <linearGradient id="Nepojmenovaný_přechod_37" x1="152.54" y1="21.69" x2="44.92" y2="21.69" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#59c9e7" />
                <stop offset="1" stop-color="#62b5e5" />
            </linearGradient>
            <linearGradient id="Nepojmenovaný_přechod_88" x1="145.66" y1="23.76" x2="190.08" y2="100.69" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#34ba9a" />
                <stop offset="1" stop-color="#a0cc3a" />
            </linearGradient>
            <linearGradient id="Nepojmenovaný_přechod_28" x1="51.75" y1="23.67" x2="7.29" y2="100.69" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#fed208" />
                <stop offset="1" stop-color="#f05223" />
            </linearGradient>
        </defs>
        <g id="Vrstva_2" data-name="Vrstva 2">
            <g id="Vrstva_2-2" data-name="Vrstva 2">
                <path
                    d="M64.11,43.33a65.43,65.43,0,0,1,69.24.06L152.54,16a98.74,98.74,0,0,0-107.62-.06Z"
                    fill={`url('${window.location.href}#Nepojmenovaný_přechod_37')`}
                />
                <path
                    d="M155.57,18,136.4,45.43a66,66,0,0,1,8.43,7.13,64.76,64.76,0,0,1,19.08,43.93h33.46A98.58,98.58,0,0,0,155.57,18Z"
                    fill={`url('${window.location.href}#Nepojmenovaný_přechod_88')`}
                />
                <path
                    d="M41.88,18A98.61,98.61,0,0,0,0,96.49H33.46A64.8,64.8,0,0,1,52.53,52.56a67.47,67.47,0,0,1,8.53-7.2Z"
                    fill={`url('${window.location.href}#Nepojmenovaný_přechod_28')`}
                />
                <circle
                    cx="98.52"
                    cy="90.73"
                    r="8.64"
                    fill={"#45484a"}
                />
            </g>
        </g>
    </svg>
);

export default SvgMonitoraViceznacny;